import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { ProjectCreationFlow } from './ProjectCreationFlow';
import { useWorkspace } from '@/store/workspace';
import { useFeatureGate } from '@/hooks/useFeatureGate';
import { UpgradePrompt } from '@/components/subscription/UpgradePrompt';

export function CreateProject() {
  const navigate = useNavigate();
  const { currentWorkspace, canEdit } = useWorkspace();
  const { canCreateProject, currentProjectCount, projectLimit, isLoading: featureGateLoading } = useFeatureGate();

  useEffect(() => {
    if (!canEdit()) {
      navigate('/projects');
    }
  }, [canEdit, navigate]);

  if (!featureGateLoading && !canCreateProject) {
    return (
      <div className="max-w-4xl mx-auto space-y-6">
        <UpgradePrompt
          type="project-limit"
          currentProjectCount={currentProjectCount}
          projectLimit={projectLimit}
          onDismiss={() => navigate('/projects')}
        />
      </div>
    );
  }

  if (!currentWorkspace) {
    return null;
  }

  return (
    <ProjectCreationFlow
      workspaceId={currentWorkspace.id}
      workspaceName={currentWorkspace.name}
      onCreated={(id) => navigate(`/projects/${id}`, { state: { fromCreate: true } })}
      onExit={() => navigate('/projects')}
      enableDraft={true}
      choiceInfoBox={
        <div className="bg-ingesta-blue-50 p-6 rounded-lg border border-ingesta-blue-200">
          <h4 className="font-semibold text-ingesta-blue-900 mb-2 flex items-center gap-2">
            <Sparkles className="h-5 w-5" />
            AI-Powered Setup
          </h4>
          <p className="text-sm text-ingesta-blue-800">
            Upload existing project documents, emails, or notes and our AI will automatically
            extract project details, milestones, risks, and more. You can review and edit
            everything before creating the project.
          </p>
        </div>
      }
    />
  );
}
